/* eslint-disable no-unused-vars */
import { Delete, Get, Post, PostFormData, Put } from "../Request";

export default {
  state: {
    Seminars: [],
    Location: [],
    Coordinators:[],
    filterOptionsData: [],
    SeminarsById: [],
    Students:[],
    seminarId:null,
    courseName:'',
    seminarCoursesAndInstructors: []
  },
  getters: {
    GetFilterOptionsData(state){
      return state.filterOptionsData.Data
    },
    GetSeminarCoursesAndInstructors(state){
      return state.seminarCoursesAndInstructors;
    },
    GetLocation(state) {
      return state.Location;
    },
    GetSeminars(state) {
      return state.Seminars;
    },
    GetStudents(state) {
      return state.Students;
    },
    GetCoordinators(state){
      return state.Coordinators;
    },
    GetSeminarById(state){
      return state.SeminarsById;
    }
  },
  actions: {
    async GetAllSeminar({ commit }, payload) {
      return await Get(`Seminar/GetAllSeminar/${payload.page}?pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.filters}`).then((res) => {
        commit("SetSeminars", res.data.Data.List);
        return res.data.Data;
      });
    },
    async GetSeminarCoursesAndInstructors({ commit }, payload) {
      return await Get(`Seminar/GetSeminarCoursesAndInstructors`).then((res) => {
        commit("SetSeminarCoursesAndInstructors", res.data.Data);
        return res.data.Data;
      });
    },
    async GetLocation({ commit }, payload) {
      return await Get(`Location/GetLocation/${payload.page}?userid=${payload.userId}&pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.filters}`).then((res) => {
        commit("SetLocation", res.data.Data);
        return res.data.Data;
      });
    },
    async AddSeminar({ commit }, payload) {
      return await PostFormData("Seminar/AddSeminar", payload).then((res) => {
        return res.data;
      });
    },
    async EditSeminar({ commit }, payload) {
      return await Put("Seminar/EditSeminar", payload).then((res) => {
        return res.data;
      });
    },
    async DeleteSeminar({ commit }, payload) {
      return await Delete(`Seminar/DeleteSeminar/${payload.Id}`).then((res) => {
        return res.data;
      });
    },
    async DeleteStudents({ commit }, payload) {
      return await Delete(`Seminar/DeleteStudent?studentId=${payload.Id}&seminarId=${payload.seminarId}`).then((res) => {
        return res.data;
      });
    },
    async ToggleSeminarVisibility({ commit }, payload) {
      return await Put(`Seminar/ToggleSeminarVisibility/${payload}`).then((res) => {
        return res.data; 
      });
    },
    async GetCoordinator({ commit }, payload) {
      return await Get(
        `Coordinator/GetInstructorCoordinatorsByInstructorId/${payload.page}?pageSize=${payload.pageSize}&instructorId=${payload.instructorId}`
      ).then((res) => {
        commit("SetCoordinators", res.data.Data.List);

        return res.data.Data;
      });
    },
    async GetFiltersOptionsData({ commit }, id) {
      return await Get(`Location/GetLocationFiltersUserId?userId=${id}`).then((res) => {
        commit("SetFiltersOptionsData", res.data);
      });
    },
    async GetSeminarById({ commit }, payload) {
      return await Get(`Seminar/GetSeminarById?id=${payload.Id}`).then((res) => {
        commit("SetSeminarsById", res.data.Data);
        return res.data.Data.List;
      });
    },
    async GetStudents({ commit }, payload) {
      return await Get(`Seminar/GetStudent?seminarId=${payload.Id}&page=${payload.page}&pageSize=${payload.pageSize}`).then((res) => {
        commit("SetStudents", res.data);
        return res.data.Data;
      });
    },
    async SendEmailToStudents({ commit }, payload) {
      return await Post(`Seminar/SendEmailToStudents`, payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async GraduateStudents({ commit }, payload) {
      return await Post(`Seminar/GraduateStudents`, payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async PaySeminarManual({ commit }, payload) {
      return await Post("Seminar/PaySeminarManual", payload).then((res) => {
        return res.data;
      });
    },
    async ManualRoyaltyPay({ commit }, payload) {
      return await Post("Seminar/ManualRoyalty", payload).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetSeminarCoursesAndInstructors(state, payload) {
      state.seminarCoursesAndInstructors = payload;
    },
    SetFiltersOptionsData(state, payload) {
      state.filterOptionsData = payload;
    },
    SetSeminars(state, payload) {
      payload.forEach((item)=>{
        item.SeminarDate = item.SeminarDateAndTimes[0]?.Date?.split("T")[0];
      })
      state.Seminars = payload;
    },
    SetStudents(state, payload) {
      state.Students = payload;
    },
    SetSeminarsById(state, payload) {
      state.SeminarsById = payload;
    },
    SetLocation(state,payload){
      state.Location = payload
    },
    SetCoordinators(state, payload) {
      payload = payload.map((x) => {
        x.ProfileImage =
          x.ProfileImage != null &&
          x.ProfileImage != undefined &&
          x.ProfileImage != ""
            // ? process.env.VUE_APP_IMG_URL + x.ProfileImage
            ? x.ProfileImage
            : "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8Nnx8fGVufDB8fHx8&w=1000&q=80";
        return x;
      });
      state.Coordinators = payload;
    },
  },
};
